import { firestore } from '../../utilities/firebase'
import getItemByItemKey from './internal'

export default getItemByItemKey(firestore)



// WEBPACK FOOTER //
// ./src/dataservices/getItemByItemKey/index.js